<div class="account-selection-page-container">
  <section>
    <app-account-selection-list
      *ngIf="accounts.length && accessToken"
      [accounts]="accounts"
      [accessToken]="accessToken"
      [sessionId]="sessionId"
      [loginHint]="loginHint"
    />
  </section>
</div>
